import axios from 'axios';

export const getCXWorkspacesAtAccountLevel = (
  ssoToken: string,
  corpAccountNumber: string,
) => {
  return axios.get(
    `/rest-api/cx/v1/corp-accounts/${corpAccountNumber}/workspaces`,
    {
      headers: {
        'Content-Type': 'application/json',
        'nextiva-context-corpAcctNumber': String(corpAccountNumber),
        Authorization: `Bearer ${ssoToken}`,
      },
      withCredentials: true,
    },
  );
};

export const getCXWorkspacesAtUserLevel = (
  ssoToken: string,
  corpAccountNumber: string,
  userUuid: string,
) => {
  return axios.get(`/rest-api/cx/v1/user/${userUuid}`, {
    headers: {
      'Content-Type': 'application/json',
      'nextiva-context-corpAcctNumber': String(corpAccountNumber),
      Authorization: `Bearer ${ssoToken}`,
    },
    withCredentials: true,
  });
};

export const updateCXUser = (
  ssoToken: string,
  corpAccountNumber: string,
  userToUpdate,
) => {
  const payload = {
    corpAccountId: Number(corpAccountNumber),
    emailId: userToUpdate?.email,
    firstName: userToUpdate?.firstName,
    lastName: userToUpdate?.lastName,
    profiles: userToUpdate?.payloadProfiles,
    timeZone: 'America/Phoenix',
    userUuid: userToUpdate?.nextivaUuid,
  };

  return axios.put('/rest-api/cx/v1/user', payload, {
    headers: {
      'Content-Type': 'application/json',
      'nextiva-context-corpAcctNumber': String(corpAccountNumber),
      Authorization: `Bearer ${ssoToken}`,
    },
    withCredentials: true,
  });
};

export const createCXUser = (
  ssoToken: string,
  corpAccountNumber: string,
  payloadProfiles: number[],
  userUuid: string,
  role: string,
) => {
  const payload = {
    corpAcctNbr: Number(corpAccountNumber),
    role: role === 'Admin' ? 'ADMIN' : 'USER',
    userUuid,
    workspaces: payloadProfiles,
  };

  return axios.post('/rest-api/cx/v1/user', payload, {
    headers: {
      'Content-Type': 'application/json',
      'nextiva-context-corpAcctNumber': String(corpAccountNumber),
      Authorization: `Bearer ${ssoToken}`,
    },
    withCredentials: true,
  });
};
